import { EyeOutlined } from "@ant-design/icons";
import { ColDef, ICellRendererParams } from "ag-grid-community";
import { AgGridReact } from "ag-grid-react";
import React, { useMemo, useState } from "react";

const InterestedCar = ({
  stData = {} as any,
  stChange = (data: any) => {},
}) => {
  // State để lưu id của dòng có icon EyeOutlined đang active
  const [activeEyeId, setActiveEyeId] = useState<string | number | null>(null);

  const columnDefs: ColDef[] = [
    {
      field: "brand",
      cellClass: "font-medium",
      headerName: "Hãng xe",
      rowGroup: true,
      rowGroupIndex: 0,
      hide: true,
    },
    {
      field: "interaction_vehicle_name",
      headerName: "Tên xe",
      minWidth: 250,
      cellClass: "font-medium",
      cellRenderer: (params: any) => {
        const node = params.node;
        const leaves = node?.allLeafChildren ?? [];
        if (node?.group) {
          if (node.level === 0) {
            return (
              <span style={{ color: "#096DD9", fontWeight: 500 }}>
                Số xe: {leaves.length}
              </span>
            );
          }
          if (node.level === 1) {
            return (
              <span style={{ color: "#096DD9", fontWeight: 500 }}>
                Số xe: {leaves.length}
              </span>
            );
          }
        }
        return params.data?.interaction_vehicle_name;
      },
    },
    {
      field: "interaction_vehicle_status",
      headerName: "Tình trạng xe",
      cellRenderer: (params: ICellRendererParams) => {
        if (!params.data) return null;
        return (
          <span className="bg-F0F5FF px-2 py-1 border border-ADC6FF rounded-lg font-light border-8px">
            {params.data.interaction_vehicle_status}
          </span>
        );
      },
    },
    {
      field: "interaction_employee_name",
      headerName: "Nhân viên chăm sóc",
      cellRenderer: (params: ICellRendererParams) => {
        if (!params.data) return null;
        return (
          <span className="text-primary">
            {params.data.interaction_employee_name}
          </span>
        );
      },
    },
    { field: "interaction_color_name", headerName: "Màu xe" },
    { field: "interaction_route_name", headerName: "Đơn vị" },
    { field: "interaction_date", headerName: "Ngày tiếp xúc gần nhất" },
    { field: "interaction_details", headerName: "Nhận định khách hàng" },
  ];

  const defaultColDef = useMemo<ColDef>(
    () => ({
      flex: 1,
      minWidth: 100,
      sortable: true,
      resizable: true,
    }),
    []
  );

  const autoGroupColumnDef = useMemo<ColDef>(
    () => ({
      headerName: "Hành động",
      minWidth: 320,
      cellRenderer: "agGroupCellRenderer",
      cellRendererParams: {
        suppressCount: true,
        suppressDoubleClickExpand: true,
        innerRenderer: (params: ICellRendererParams) => {
          const node: any = params.node;
          const label = params.value;
          if (node.group) {
            return <span>{`${label}`}</span>;
          }
          const id = params.data?.id;

          return (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                width: "100%",
              }}
            >
              <span>{label}</span>
              <div
                onClick={(e) => e.stopPropagation()}
                style={{ display: "flex", gap: 13 }}
              >
                <EyeOutlined
                  className={`text-sm border-D9D9D9 p-5-px bg-white rounded-2 cursor-pointer fs-14 border-8px${
                    activeEyeId === params.data.interaction_vehicle_name ? " active" : ""
                  }`}
                  onClick={() => {
                    setActiveEyeId(params.data.interaction_vehicle_name);
                    stChange({
                      xequantam_show: params.data.interaction_vehicle_name,
                    });
                  }}
                />
              </div>
            </div>
          );
        },
      },
    }),
    [activeEyeId, stChange]
  );

  return (
    <>
      <div
        className="ag-theme-alpine custom-table-ag custom-page-css custom-tabs"
        style={{ width: "100%" }}
      >
        <AgGridReact
          rowData={stData.xequantam0 || []}
          columnDefs={columnDefs}
          rowHeight={55}
          domLayout="autoHeight"
          className="my-auto-height-grid"
          defaultColDef={defaultColDef}
          autoGroupColumnDef={autoGroupColumnDef}
          groupDefaultExpanded={0}
          animateRows={true}
        />
      </div>
      {/* CSS cho icon active */}
      <style>
        {`
          .ag-theme-alpine .anticon.active {
            color: #1890ff;
            border: 1.5px solid #1890ff;
            background: #e6f7ff;
          }
        `}
      </style>
    </>
  );
};

export default InterestedCar;
